import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsDownloadedConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-downloaded-details",
  templateUrl: "./manuals-downloaded-details.component.html",
  standalone: false,
})
export class ManualsDownloadedDetailsComponent
  extends BaseDetailsLogic<ManualsDownloadedConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, ManualsDownloadedConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
      this.detectSettingsChange();
      this.refreshDataFromFilters();
  }

  get selectedMinDownloads(): number {
    return this.config?.minDownloads || 0;
  }

  set selectedMinDownloads(value: number) {
    this.config.minDownloads = value;
      this.detectSettingsChange();
      this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod: 'Choose a time period to see how many manuals were downloaded during that time. For example, you can look at downloads from the last week, month, or year. This helps you understand when people are most interested in your manuals.',
      minDownloads: 'Set the minimum number of downloads to filter the results. For example, if you only want to see manuals that have been downloaded at least 10 times, enter 10 here. This helps you focus on the most popular manuals.'
    };
  }
}
